const pathConstants = {
  PRO_RESOURCE_PREFIX: '/m/ws/',
  PRO_RESOURCE_PREFIX_WD: '/m/wd/'
}

export default pathConstants
